var map = {
	"./": [
		310,
		9
	],
	"./UserSettings": [
		1161,
		9,
		5,
		13,
		151
	],
	"./UserSettings.dictionary": [
		344,
		3
	],
	"./UserSettings.dictionary.json": [
		344,
		3
	],
	"./UserSettings.tsx": [
		1161,
		9,
		5,
		13,
		151
	],
	"./UserSettingsDeferred": [
		377,
		9
	],
	"./UserSettingsDeferred.tsx": [
		377,
		9
	],
	"./components/ChangeButton": [
		866,
		9,
		40
	],
	"./components/ChangeButton/": [
		866,
		9,
		40
	],
	"./components/ChangeButton/ChangeButton.module.scss": [
		942,
		9,
		294
	],
	"./components/ChangeButton/index": [
		866,
		9,
		40
	],
	"./components/ChangeButton/index.tsx": [
		866,
		9,
		40
	],
	"./components/SettingToggler": [
		923,
		9,
		61
	],
	"./components/SettingToggler/": [
		923,
		9,
		61
	],
	"./components/SettingToggler/SettingToggler.module.scss": [
		1056,
		9,
		316
	],
	"./components/SettingToggler/index": [
		923,
		9,
		61
	],
	"./components/SettingToggler/index.tsx": [
		923,
		9,
		61
	],
	"./components/SettingsLoader": [
		940,
		9,
		62
	],
	"./components/SettingsLoader/": [
		940,
		9,
		62
	],
	"./components/SettingsLoader/index": [
		940,
		9,
		62
	],
	"./components/SettingsLoader/index.tsx": [
		940,
		9,
		62
	],
	"./components/SettingsSection": [
		837,
		9,
		63
	],
	"./components/SettingsSection/": [
		837,
		9,
		63
	],
	"./components/SettingsSection/SettingsSection.module.scss": [
		855,
		9,
		317
	],
	"./components/SettingsSection/index": [
		837,
		9,
		63
	],
	"./components/SettingsSection/index.tsx": [
		837,
		9,
		63
	],
	"./components/ThemeSetting": [
		992,
		9,
		74
	],
	"./components/ThemeSetting/": [
		992,
		9,
		74
	],
	"./components/ThemeSetting/ThemeSetting": [
		993,
		9,
		221
	],
	"./components/ThemeSetting/ThemeSetting.dictionary": [
		939,
		3,
		222
	],
	"./components/ThemeSetting/ThemeSetting.dictionary.json": [
		939,
		3,
		222
	],
	"./components/ThemeSetting/ThemeSetting.explanation": [
		1162,
		9,
		223
	],
	"./components/ThemeSetting/ThemeSetting.explanation.ts": [
		1162,
		9,
		223
	],
	"./components/ThemeSetting/ThemeSetting.module.scss": [
		1052,
		9,
		325
	],
	"./components/ThemeSetting/ThemeSetting.tsx": [
		993,
		9,
		221
	],
	"./components/ThemeSetting/components/ThemeCardWrapper": [
		910,
		9,
		75
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/": [
		910,
		9,
		75
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper": [
		884,
		9,
		224
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.module.scss": [
		938,
		9,
		326
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/ThemeCardWrapper.tsx": [
		884,
		9,
		224
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard": [
		865,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/": [
		865,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard": [
		849,
		9,
		225
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.module.scss": [
		885,
		9,
		327
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/ThemeCard.tsx": [
		849,
		9,
		225
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem": [
		850,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/": [
		850,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem": [
		840,
		9,
		226
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.module.scss": [
		856,
		9,
		328
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/ThemeCardItem.tsx": [
		840,
		9,
		226
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index": [
		850,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/components/ThemeCardItem/index.ts": [
		850,
		9,
		77
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index": [
		865,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/components/ThemeCard/index.ts": [
		865,
		9,
		76
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/index": [
		910,
		9,
		75
	],
	"./components/ThemeSetting/components/ThemeCardWrapper/index.ts": [
		910,
		9,
		75
	],
	"./components/ThemeSetting/index": [
		992,
		9,
		74
	],
	"./components/ThemeSetting/index.ts": [
		992,
		9,
		74
	],
	"./components/UserMainSettings": [
		994,
		9,
		5,
		79
	],
	"./components/UserMainSettings/": [
		994,
		9,
		5,
		79
	],
	"./components/UserMainSettings/UserContacts": [
		941,
		9,
		5,
		80
	],
	"./components/UserMainSettings/UserContacts/": [
		941,
		9,
		5,
		80
	],
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary": [
		998,
		3,
		228
	],
	"./components/UserMainSettings/UserContacts/UserContacts.dictionary.json": [
		998,
		3,
		228
	],
	"./components/UserMainSettings/UserContacts/index": [
		941,
		9,
		5,
		80
	],
	"./components/UserMainSettings/UserContacts/index.tsx": [
		941,
		9,
		5,
		80
	],
	"./components/UserMainSettings/UserEmail": [
		960,
		9,
		5,
		81
	],
	"./components/UserMainSettings/UserEmail/": [
		960,
		9,
		5,
		81
	],
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary": [
		961,
		3,
		229
	],
	"./components/UserMainSettings/UserEmail/UserEmail.dictionary.json": [
		961,
		3,
		229
	],
	"./components/UserMainSettings/UserEmail/UserEmail.module.scss": [
		867,
		9,
		329
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal": [
		995,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/": [
		995,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary": [
		1055,
		3,
		230
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/EmailModal.dictionary.json": [
		1055,
		3,
		230
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/index": [
		995,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/EmailModal/index.tsx": [
		995,
		9,
		82
	],
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm": [
		943,
		9,
		231
	],
	"./components/UserMainSettings/UserEmail/components/Forms/CodeForm.tsx": [
		943,
		9,
		231
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm": [
		887,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/": [
		887,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary": [
		912,
		3,
		232
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/EmailForm.dictionary.json": [
		912,
		3,
		232
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index": [
		887,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/Forms/EmailForm/index.tsx": [
		887,
		9,
		83
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody": [
		911,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/": [
		911,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary": [
		944,
		3,
		233
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/ModalBody.dictionary.json": [
		944,
		3,
		233
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/index": [
		911,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalBody/index.tsx": [
		911,
		9,
		84
	],
	"./components/UserMainSettings/UserEmail/components/ModalContent": [
		1054,
		9,
		234
	],
	"./components/UserMainSettings/UserEmail/components/ModalContent.tsx": [
		1054,
		9,
		234
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter": [
		996,
		9,
		235
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary": [
		945,
		3,
		236
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter.dictionary.json": [
		945,
		3,
		236
	],
	"./components/UserMainSettings/UserEmail/components/ModalFooter.tsx": [
		996,
		9,
		235
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader": [
		913,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/": [
		913,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary": [
		946,
		3,
		237
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/ModalHeader.dictionary.json": [
		946,
		3,
		237
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index": [
		913,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/components/ModalHeader/index.tsx": [
		913,
		9,
		85
	],
	"./components/UserMainSettings/UserEmail/constants": [
		851,
		9,
		238
	],
	"./components/UserMainSettings/UserEmail/constants.ts": [
		851,
		9,
		238
	],
	"./components/UserMainSettings/UserEmail/email-form-validation": [
		1053,
		9,
		239
	],
	"./components/UserMainSettings/UserEmail/email-form-validation.ts": [
		1053,
		9,
		239
	],
	"./components/UserMainSettings/UserEmail/index": [
		960,
		9,
		5,
		81
	],
	"./components/UserMainSettings/UserEmail/index.tsx": [
		960,
		9,
		5,
		81
	],
	"./components/UserMainSettings/UserMainSettings.module.scss": [
		997,
		9,
		330
	],
	"./components/UserMainSettings/UserPersonalData": [
		914,
		9,
		86
	],
	"./components/UserMainSettings/UserPersonalData/": [
		914,
		9,
		86
	],
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary": [
		947,
		3,
		240
	],
	"./components/UserMainSettings/UserPersonalData/UserPersonalData.dictionary.json": [
		947,
		3,
		240
	],
	"./components/UserMainSettings/UserPersonalData/index": [
		914,
		9,
		86
	],
	"./components/UserMainSettings/UserPersonalData/index.tsx": [
		914,
		9,
		86
	],
	"./components/UserMainSettings/index": [
		994,
		9,
		5,
		79
	],
	"./components/UserMainSettings/index.tsx": [
		994,
		9,
		5,
		79
	],
	"./components/UserMainSettings/tests/__snapshots__/user-personal-data.spec.jsx.snap": [
		1202,
		9,
		331
	],
	"./components/UserMainSettings/tests/get-component-by-datatest-util": [
		1117,
		9,
		241
	],
	"./components/UserMainSettings/tests/get-component-by-datatest-util.js": [
		1117,
		9,
		241
	],
	"./components/UserMainSettings/tests/user-personal-data.spec": [
		1163,
		9,
		266,
		242
	],
	"./components/UserMainSettings/tests/user-personal-data.spec.jsx": [
		1163,
		9,
		266,
		242
	],
	"./components/UserSecuritySettings": [
		1028,
		9,
		13,
		87
	],
	"./components/UserSecuritySettings/": [
		1028,
		9,
		13,
		87
	],
	"./components/UserSecuritySettings/ModalBody": [
		949,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalBody/": [
		949,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary": [
		999,
		3,
		243
	],
	"./components/UserSecuritySettings/ModalBody/ModalBody.dictionary.json": [
		999,
		3,
		243
	],
	"./components/UserSecuritySettings/ModalBody/index": [
		949,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalBody/index.tsx": [
		949,
		9,
		88
	],
	"./components/UserSecuritySettings/ModalFooter": [
		1058,
		9,
		244
	],
	"./components/UserSecuritySettings/ModalFooter.tsx": [
		1058,
		9,
		244
	],
	"./components/UserSecuritySettings/ModalResponseError": [
		915,
		9,
		89
	],
	"./components/UserSecuritySettings/ModalResponseError/": [
		915,
		9,
		89
	],
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary": [
		950,
		3,
		245
	],
	"./components/UserSecuritySettings/ModalResponseError/ModalResponseError.dictionary.json": [
		950,
		3,
		245
	],
	"./components/UserSecuritySettings/ModalResponseError/index": [
		915,
		9,
		89
	],
	"./components/UserSecuritySettings/ModalResponseError/index.tsx": [
		915,
		9,
		89
	],
	"./components/UserSecuritySettings/PasswordModal": [
		1091,
		9,
		246
	],
	"./components/UserSecuritySettings/PasswordModal.tsx": [
		1091,
		9,
		246
	],
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary": [
		857,
		3,
		247
	],
	"./components/UserSecuritySettings/UserSecuritySettings.dictionary.json": [
		857,
		3,
		247
	],
	"./components/UserSecuritySettings/UserSecuritySettings.module.scss": [
		858,
		9,
		332
	],
	"./components/UserSecuritySettings/changePassword": [
		948,
		9,
		248
	],
	"./components/UserSecuritySettings/changePassword.ts": [
		948,
		9,
		248
	],
	"./components/UserSecuritySettings/constants": [
		1057,
		9,
		249
	],
	"./components/UserSecuritySettings/constants.ts": [
		1057,
		9,
		249
	],
	"./components/UserSecuritySettings/index": [
		1028,
		9,
		13,
		87
	],
	"./components/UserSecuritySettings/index.tsx": [
		1028,
		9,
		13,
		87
	],
	"./components/UserSecuritySettings/password-form-validation": [
		1059,
		9,
		250
	],
	"./components/UserSecuritySettings/password-form-validation.ts": [
		1059,
		9,
		250
	],
	"./components/UserStakeSettings": [
		1000,
		9,
		90
	],
	"./components/UserStakeSettings/": [
		1000,
		9,
		90
	],
	"./components/UserStakeSettings/UserStakeSettings.dictionary": [
		1060,
		3,
		251
	],
	"./components/UserStakeSettings/UserStakeSettings.dictionary.json": [
		1060,
		3,
		251
	],
	"./components/UserStakeSettings/index": [
		1000,
		9,
		90
	],
	"./components/UserStakeSettings/index.tsx": [
		1000,
		9,
		90
	],
	"./components/constants": [
		886,
		9,
		252
	],
	"./components/constants.ts": [
		886,
		9,
		252
	],
	"./components/types": [
		1061,
		7,
		91
	],
	"./components/types/": [
		1061,
		7,
		91
	],
	"./components/types/index": [
		1061,
		7,
		91
	],
	"./components/types/index.ts": [
		1061,
		7,
		91
	],
	"./components/types/userEmail": [
		1164,
		7,
		253
	],
	"./components/types/userEmail.ts": [
		1164,
		7,
		253
	],
	"./components/types/userPhone": [
		1165,
		7,
		254
	],
	"./components/types/userPhone.ts": [
		1165,
		7,
		254
	],
	"./components/utils/error-alert-utils": [
		376,
		9
	],
	"./components/utils/error-alert-utils.ts": [
		376,
		9
	],
	"./components/utils/hide-symbols-utils": [
		1090,
		9,
		255
	],
	"./components/utils/hide-symbols-utils.ts": [
		1090,
		9,
		255
	],
	"./index": [
		310,
		9
	],
	"./index.tsx": [
		310,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1280;
module.exports = webpackAsyncContext;